import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";

import { EventPlace, trackEngagement } from "helpers/analytics";
import { WelcomeTutorialViewActions } from "store/views/welcome-tutorial";

export const FinishStandaloneAppTutorial: FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    trackEngagement("Welcome tutorial: Finished", EventPlace.WelcomeTutorial);
    dispatch(WelcomeTutorialViewActions.finish());
  }, []);

  return null;
};
